module.exports = __webpack_public_path__ + "static/media/upp_flo_exc_zon.87a4dbb9.png";